import { RouteRecordRaw } from "vue-router"
import { UserRouteNameEnum } from "@/shared/enums/routes/user.enum.ts"

export const userRoutes: RouteRecordRaw[] = [
	{
		path: "/user/details",
		name: UserRouteNameEnum.details,
		component: () => import("@/pages/user/DetailsPage.vue"),
		meta: {
			title: UserRouteNameEnum.details,
			layout: "EmptyLayout",
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY", "SCREEN_OWNER"],
		},
	},
	{
		path: "/user/account-status",
		name: UserRouteNameEnum.accountStatus,
		component: () => import("@/pages/user/AccountStatusPage.vue"),
		meta: {
			title: UserRouteNameEnum.accountStatus,
			layout: "EmptyLayout",
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY", "SCREEN_OWNER"],
		},
	},
	{
		path: "/user-profile/general",
		name: UserRouteNameEnum.profileGeneral,
		component: () => import("@/pages/user/ProfileGeneralPage.vue"),
		meta: {
			title: UserRouteNameEnum.profileGeneral,
			layout: "MainLayout",
			hasProfileSidebar: true,
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY", "SCREEN_OWNER"],
		},
	},
	{
		path: "/user-profile/notifications",
		name: UserRouteNameEnum.profileNotifications,
		component: () => import("@/pages/user/ProfileNotificationsPage.vue"),
		meta: {
			title: UserRouteNameEnum.profileNotifications,
			layout: "MainLayout",
			hasProfileSidebar: true,
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY", "SCREEN_OWNER"],
		},
	},
	{
		path: "/user-profile/edit",
		name: UserRouteNameEnum.profileEdit,
		component: () => import("@/pages/user/ProfileEditPage.vue"),
		meta: {
			title: UserRouteNameEnum.profileEdit,
			layout: "MainLayout",
			hasProfileSidebar: true,
			authRequired: true,
			allowedRoles: ["ADVERTISER_COMPANY", "ADS_AGENCY", "SCREEN_OWNER"],
		},
	},
];
